// App
export const REQUEST_APP_LOAD = 'REQUEST_APP_LOAD';
export const RECEIVE_APP_LOAD = 'RECEIVE_APP_LOAD';
export const OPEN_NAVIGATION = 'OPEN_NAVIGATION';
export const CLOSE_NAVIGATION = 'CLOSE_NAVIGATION';
export const REQUEST_UPLOAD_IMAGE = 'REQUEST_UPLOAD_IMAGE';
export const RECEIVE_UPLOAD_IMAGE = 'RECEIVE_UPLOAD_IMAGE';
export const CHECK_LIFETIME = 'CHECK_LIFETIME';
export const UPDATE_VEHICLE_TYPE_FILTER = 'UPDATE_VEHICLE_TYPE_FILTER';

// Auth
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const REJECT_LOGIN = 'REJECT_LOGIN';
export const RECEIVE_LOGIN = 'RECEIVE_LOGIN';
export const LOGOUT = 'LOGOUT';
export const VALIDATE_AUTH = 'VALIDATE_AUTH';
export const SWITCH_ACCOUNT = 'SWITCH_ACCOUNT';

// Base actions
export const REQUEST_ADD = 'REQUEST_ADD';
export const RECEIVE_ADD = 'RECEIVE_ADD';
export const REQUEST = 'REQUEST';
export const RECEIVE = 'RECEIVE';
export const REQUEST_UPDATE = 'REQUEST_UPDATE';
export const RECEIVE_UPDATE = 'RECEIVE_UPDATE';
export const REQUEST_REMOVE = 'REQUEST_REMOVE';
export const RECEIVE_REMOVE = 'RECEIVE_REMOVE';

export const REQUEST_PENDING_ACCOUNT_EXPORT = 'REQUEST_PENDING_ACCOUNT_EXPORT';
export const RECEIVE_PENDING_ACCOUNT_EXPORT = 'RECEIVE_PENDING_ACCOUNT_EXPORT';

// Users
export const REQUEST_USERS = 'REQUEST_USERS';
export const RECEIVE_USERS = 'RECEIVE_USERS';
export const REQUEST_USER = 'REQUEST_USER';
export const RECEIVE_USER = 'RECEIVE_USER';
export const REQUEST_ADD_USER = 'REQUEST_ADD_USER';
export const RECEIVE_ADD_USER = 'RECEIVE_ADD_USER';
export const REQUEST_REMOVE_USER = 'REQUEST_REMOVE_USER';
export const RECEIVE_REMOVE_USER = 'RECEIVE_REMOVE_USER';
export const REQUEST_USER_PERMISSIONS = 'REQUEST_USER_PERMISSIONS';
export const RECEIVE_USER_PERMISSIONS = 'RECEIVE_USER_PERMISSIONS';
export const REQUEST_ADD_PERMISSION_TO_USER = 'REQUEST_ADD_PERMISSION_TO_USER';
export const RECEIVE_ADD_PERMISSION_TO_USER = 'RECEIVE_ADD_PERMISSION_TO_USER';
export const REQUEST_REMOVE_PERMISSION_FROM_USER =
  'REQUEST_REMOVE_PERMISSION_FROM_USER';
export const RECEIVE_REMOVE_PERMISSION_FROM_USER =
  'RECEIVE_REMOVE_PERMISSION_FROM_USER';
export const REQUEST_ADD_ACCOUNT_TO_USER = 'REQUEST_ADD_ACCOUNT_TO_USER';
export const RECEIVE_ADD_ACCOUNT_TO_USER = 'RECEIVE_ADD_ACCOUNT_TO_USER';
export const REQUEST_REMOVE_ACCOUNT_FROM_USER =
  'REQUEST_REMOVE_ACCOUNT_FROM_USER';
export const RECEIVE_REMOVE_ACCOUNT_FROM_USER =
  'RECEIVE_REMOVE_ACCOUNT_FROM_USER';
export const SHOW_USER_ERROR = 'SHOW_USER_ERROR';
export const CLEAR_USER_ERRORS = 'CLEAR_USER_ERRORS';
export const REQUEST_USER_ACCOUNTS = 'REQUEST_USER_ACCOUNTS';
export const RECEIVE_USER_ACCOUNTS = 'RECEIVE_USER_ACCOUNTS';
export const REQUEST_ADD_DEFAULT_ACCOUNT_TO_USER =
  'REQUEST_ADD_DEFAULT_ACCOUNT_TO_USER';
export const RECEIVE_ADD_DEFAULT_ACCOUNT_TO_USER =
  'RECEIVE_ADD_DEFAULT_ACCOUNT_TO_USER';

// Vehicle
export const REQUEST_ADD_VEHICLE = 'REQUEST_ADD_VEHICLE';
export const RECEIVE_ADD_VEHICLE = 'RECEIVE_ADD_VEHICLE';
export const REQUEST_VEHICLES = 'REQUEST_VEHICLES';
export const RECEIVE_VEHICLES = 'RECEIVE_VEHICLES';
export const REQUEST_VEHICLES_ALL = 'REQUEST_VEHICLES_ALL';
export const RECEIVE_VEHICLES_ALL = 'RECEIVE_VEHICLES_ALL';
export const REQUEST_VEHICLE = 'REQUEST_VEHICLE';
export const RECEIVE_VEHICLE = 'RECEIVE_VEHICLE';
export const REQUEST_UPDATE_VEHICLE = 'REQUEST_UPDATE_VEHICLE';
export const RECEIVE_UPDATE_VEHICLE = 'RECEIVE_UPDATE_VEHICLE';
export const REQUEST_REMOVE_VEHICLE = 'REQUEST_REMOVE_VEHICLE';
export const RECEIVE_REMOVE_VEHICLE = 'RECEIVE_REMOVE_VEHICLE';
export const SHOW_VEHICLE_ERROR = 'SHOW_VEHICLE_ERROR';
export const CLEAR_VEHICLE_ERRORS = 'CLEAR_VEHICLE_ERRORS';

// Vehicle Types
export const REQUEST_ADD_VEHICLE_TYPE = 'REQUEST_ADD_VEHICLE_TYPE';
export const RECEIVE_ADD_VEHICLE_TYPE = 'RECEIVE_ADD_VEHICLE_TYPE';
export const REQUEST_VEHICLE_TYPES = 'REQUEST_VEHICLE_TYPES';
export const RECEIVE_VEHICLE_TYPES = 'RECEIVE_VEHICLE_TYPES';
export const REQUEST_VEHICLE_TYPES_ALL = 'REQUEST_VEHICLE_TYPES_ALL';
export const RECEIVE_VEHICLE_TYPES_ALL = 'RECEIVE_VEHICLE_TYPES_ALL';
export const REQUEST_VEHICLE_TYPE = 'REQUEST_VEHICLE_TYPE';
export const RECEIVE_VEHICLE_TYPE = 'RECEIVE_VEHICLE_TYPE';
export const REQUEST_UPDATE_VEHICLE_TYPE = 'REQUEST_UPDATE_VEHICLE_TYPE';
export const RECEIVE_UPDATE_VEHICLE_TYPE = 'RECEIVE_UPDATE_VEHICLE_TYPE';
export const REQUEST_REMOVE_VEHICLE_TYPE = 'REQUEST_REMOVE_VEHICLE_TYPE';
export const RECEIVE_REMOVE_VEHICLE_TYPE = 'RECEIVE_REMOVE_VEHICLE_TYPE';
export const SHOW_VEHICLE_TYPE_ERROR = 'SHOW_VEHICLE_TYPE_ERROR';
export const CLEAR_VEHICLE_TYPE_ERRORS = 'CLEAR_VEHICLE_TYPE_ERRORS';
export const REQUEST_VEHICLE_TYPE_HIRE_COST = 'REQUEST_VEHICLE_TYPE_HIRE_COST';
export const RECEIVE_VEHICLE_TYPE_HIRE_COST = 'RECEIVE_VEHICLE_TYPE_HIRE_COST';

// Companies
export const REQUEST_ADD_COMPANY = 'REQUEST_ADD_COMPANY';
export const RECEIVE_ADD_COMPANY = 'RECEIVE_ADD_COMPANY';
export const REQUEST_COMPANIES = 'REQUEST_COMPANIES';
export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES';
export const REQUEST_COMPANIES_ALL = 'REQUEST_COMPANIES_ALL';
export const RECEIVE_COMPANIES_ALL = 'RECEIVE_COMPANIES_ALL';
export const REQUEST_COMPANY = 'REQUEST_COMPANY';
export const RECEIVE_COMPANY = 'RECEIVE_COMPANY';
export const REQUEST_UPDATE_COMPANY = 'REQUEST_UPDATE_COMPANY';
export const RECEIVE_UPDATE_COMPANY = 'RECEIVE_UPDATE_COMPANY';
export const REQUEST_REMOVE_COMPANY = 'REQUEST_REMOVE_COMPANY';
export const RECEIVE_REMOVE_COMPANY = 'RECEIVE_REMOVE_COMPANY';
export const SHOW_COMPANY_ERROR = 'SHOW_COMPANY_ERROR';
export const CLEAR_COMPANY_ERRORS = 'CLEAR_COMPANY_ERRORS';
export const REQUEST_SEARCH_COMPANIES = 'REQUEST_SEARCH_COMPANIES';
export const RECEIVE_SEARCH_COMPANIES = 'RECEIVE_SEARCH_COMPANIES';
export const REQUEST_COMPANY_BOOKINGS = 'REQUEST_COMPANY_BOOKINGS';
export const RECEIVE_COMPANY_BOOKINGS = 'RECEIVE_COMPANY_BOOKINGS';
export const REQUEST_COMPANY_PAYMENTS = 'REQUEST_COMPANY_PAYMENTS';
export const RECEIVE_COMPANY_PAYMENTS = 'RECEIVE_COMPANY_PAYMENTS';
export const REQUEST_MERGE_COMPANIES = 'REQUEST_MERGE_COMPANIES';
export const RECEIVE_MERGE_COMPANIES = 'RECEIVE_MERGE_COMPANIES';

// Drivers
export const REQUEST_ADD_DRIVER = 'REQUEST_ADD_DRIVER';
export const RECEIVE_ADD_DRIVER = 'RECEIVE_ADD_DRIVER';
export const REQUEST_DRIVERS = 'REQUEST_DRIVERS';
export const RECEIVE_DRIVERS = 'RECEIVE_DRIVERS';
export const REQUEST_DRIVERS_ALL = 'REQUEST_DRIVERS_ALL';
export const RECEIVE_DRIVERS_ALL = 'RECEIVE_DRIVERS_ALL';
export const REQUEST_DRIVER = 'REQUEST_DRIVER';
export const RECEIVE_DRIVER = 'RECEIVE_DRIVER';
export const REQUEST_UPDATE_DRIVER = 'REQUEST_UPDATE_DRIVER';
export const RECEIVE_UPDATE_DRIVER = 'RECEIVE_UPDATE_DRIVER';
export const REQUEST_REMOVE_DRIVER = 'REQUEST_REMOVE_DRIVER';
export const RECEIVE_REMOVE_DRIVER = 'RECEIVE_REMOVE_DRIVER';
export const SHOW_DRIVER_ERROR = 'SHOW_DRIVER_ERROR';
export const CLEAR_DRIVER_ERRORS = 'CLEAR_DRIVER_ERRORS';
export const REQUEST_SEARCH_DRIVERS = 'REQUEST_SEARCH_DRIVERS';
export const RECEIVE_SEARCH_DRIVERS = 'RECEIVE_SEARCH_DRIVERS';
export const REQUEST_DRIVER_PAYMENTS = 'REQUEST_DRIVER_PAYMENTS';
export const RECEIVE_DRIVER_PAYMENTS = 'RECEIVE_DRIVER_PAYMENTS';
export const REQUEST_COMPANY_DRIVERS = 'REQUEST_COMPANY_DRIVERS';
export const RECEIVE_COMPANY_DRIVERS = 'RECEIVE_COMPANY_DRIVERS';
export const REQUEST_MERGE_DRIVERS = 'REQUEST_MERGE_DRIVERS';
export const RECEIVE_MERGE_DRIVERS = 'RECEIVE_MERGE_DRIVERS';

// Notes
export const REQUEST_ADD_NOTE = 'REQUEST_ADD_NOTE';
export const RECEIVE_ADD_NOTE = 'RECEIVE_ADD_NOTE';
export const REQUEST_NOTES = 'REQUEST_NOTES';
export const RECEIVE_NOTES = 'RECEIVE_NOTES';
export const REQUEST_NOTES_ALL = 'REQUEST_NOTES_ALL';
export const RECEIVE_NOTES_ALL = 'RECEIVE_NOTES_ALL';
export const REQUEST_NOTE = 'REQUEST_NOTE';
export const RECEIVE_NOTE = 'RECEIVE_NOTE';
export const REQUEST_UPDATE_NOTE = 'REQUEST_UPDATE_NOTE';
export const RECEIVE_UPDATE_NOTE = 'RECEIVE_UPDATE_NOTE';
export const REQUEST_REMOVE_NOTE = 'REQUEST_REMOVE_NOTE';
export const RECEIVE_REMOVE_NOTE = 'RECEIVE_REMOVE_NOTE';
export const SHOW_NOTE_ERROR = 'SHOW_NOTE_ERROR';
export const CLEAR_NOTE_ERRORS = 'CLEAR_NOTE_ERRORS';
export const REQUEST_ASSIGN_NOTE = 'REQUEST_ASSIGN_NOTE';
export const RECEIVE_ASSIGN_NOTE = 'RECEIVE_ASSIGN_NOTE';
export const REQUEST_UNASSIGN_NOTE = 'REQUEST_UNASSIGN_NOTE';
export const RECEIVE_UNASSIGN_NOTE = 'RECEIVE_UNASSIGN_NOTE';
export const REQUEST_GET_NOTES_ASSIGNED_USERS =
  'REQUEST_GET_NOTES_ASSIGNED_USERS';
export const RECEIVE_GET_NOTES_ASSIGNED_USERS =
  'RECEIVE_GET_NOTES_ASSIGNED_USERS';

// History
export const REQUEST_HISTORY_MONTH = 'REQUEST_HISTORY_MONTH';
export const RECEIVE_HISTORY_MONTH = 'RECEIVE_HISTORY_MONTH';
export const REQUEST_HISTORY_DAY = 'REQUEST_HISTORY_DAY';
export const RECEIVE_HISTORY_DAY = 'RECEIVE_HISTORY_DAY';

// Holidays
export const REQUEST_HOLIDAY_RANGE = 'REQUEST_HOLIDAY_RANGE';
export const RECEIVE_HOLIDAY_RANGE = 'RECEIVE_HOLIDAY_RANGE';

// Reservations
export const REQUEST_RESERVATION_RANGE = 'REQUEST_RESERVATION_RANGE';
export const RECEIVE_RESERVATION_RANGE = 'RECEIVE_RESERVATION_RANGE';
export const REQUEST_RESERVATION_SET_PROVISIONAL_VEHICLE =
  'REQUEST_RESERVATION_SET_PROVISIONAL_VEHICLE';
export const RECEIVE_RESERVATION_SET_PROVISIONAL_VEHICLE =
  'RECEIVE_RESERVATION_SET_PROVISIONAL_VEHICLE';

// Accessories
export const REQUEST_ADD_ACCESSORY = 'REQUEST_ADD_ACCESSORY';
export const RECEIVE_ADD_ACCESSORY = 'RECEIVE_ADD_ACCESSORY';
export const REQUEST_ACCESSORIES = 'REQUEST_ACCESSORIES';
export const RECEIVE_ACCESSORIES = 'RECEIVE_ACCESSORIES';
export const REQUEST_ACCESSORY = 'REQUEST_ACCESSORY';
export const RECEIVE_ACCESSORY = 'RECEIVE_ACCESSORY';
export const REQUEST_UPDATE_ACCESSORY = 'REQUEST_UPDATE_ACCESSORY';
export const RECEIVE_UPDATE_ACCESSORY = 'RECEIVE_UPDATE_ACCESSORY';
export const REQUEST_REMOVE_ACCESSORY = 'REQUEST_REMOVE_ACCESSORY';
export const RECEIVE_REMOVE_ACCESSORY = 'RECEIVE_REMOVE_ACCESSORY';
export const SHOW_ACCESSORY_ERROR = 'SHOW_ACCESSORY_ERROR';
export const CLEAR_ACCESSORY_ERRORS = 'CLEAR_ACCESSORY_ERRORS';

// Bookings
export const REQUEST_BOOKING_PAYMENT_STATUS = 'REQUEST_BOOKING_PAYMENT_STATUS';
export const RECEIVE_BOOKING_PAYMENT_STATUS = 'RECEIVE_BOOKING_PAYMENT_STATUS';
export const REQUEST_BOOKING_RANGE = 'REQUEST_BOOKING_RANGE';
export const RECEIVE_BOOKING_RANGE = 'RECEIVE_BOOKING_RANGE';
export const REQUEST_ADD_BOOKING = 'REQUEST_ADD_BOOKING';
export const RECEIVE_ADD_BOOKING = 'RECEIVE_ADD_BOOKING';
export const REQUEST_BOOKING = 'REQUEST_BOOKING';
export const RECEIVE_BOOKING = 'RECEIVE_BOOKING';
export const REQUEST_UPDATE_BOOKING = 'REQUEST_UPDATE_BOOKING';
export const RECEIVE_UPDATE_BOOKING = 'RECEIVE_UPDATE_BOOKING';
export const REQUEST_REMOVE_BOOKING = 'REQUEST_REMOVE_BOOKING';
export const RECEIVE_REMOVE_BOOKING = 'RECEIVE_REMOVE_BOOKING';
export const REQUEST_BOOKING_COLLECTION_TIMES =
  'REQUEST_BOOKING_COLLECTION_TIMES';
export const RECEIVE_BOOKING_COLLECTION_TIMES =
  'RECEIVE_BOOKING_COLLECTION_TIMES';
export const SHOW_BOOKING_ERROR = 'SHOW_BOOKING_ERROR';
export const CLEAR_BOOKING_ERRORS = 'CLEAR_BOOKING_ERRORS';
export const REQUEST_PAY_BOOKING = 'REQUEST_PAY_BOOKING';
export const RECEIVE_PAY_BOOKING = 'RECEIVE_PAY_BOOKING';
export const REQUEST_VALIDATE_BOOKING = 'REQUEST_VALIDATE_BOOKING';
export const RECEIVE_VALIDATE_BOOKING = 'RECEIVE_VALIDATE_BOOKING';
export const REQUEST_BOOKING_VEHICLES = 'REQUEST_BOOKING_VEHICLES';
export const RECEIVE_BOOKING_VEHICLES = 'RECEIVE_BOOKING_VEHICLES';
export const REQUEST_APPROVE_BOOKING = 'REQUEST_APPROVE_BOOKING';
export const RECEIVE_APPROVE_BOOKING = 'RECEIVE_APPROVE_BOOKING';
export const REQUEST_DISAPPROVE_BOOKING = 'REQUEST_DISAPPROVE_BOOKING';
export const RECEIVE_DISAPPROVE_BOOKING = 'RECEIVE_DISAPPROVE_BOOKING';
export const REQUEST_ASSIGN_BOOKING = 'REQUEST_ASSIGN_BOOKING';
export const RECEIVE_ASSIGN_BOOKING = 'RECEIVE_ASSIGN_BOOKING';
export const REQUEST_UNASSIGN_BOOKING = 'REQUEST_UNASSIGN_BOOKING';
export const RECEIVE_UNASSIGN_BOOKING = 'RECEIVE_UNASSIGN_BOOKING';
export const REQUEST_DISPATCH_BOOKING = 'REQUEST_DISPATCH_BOOKING';
export const RECEIVE_DISPATCH_BOOKING = 'RECEIVE_DISPATCH_BOOKING';
export const REQUEST_BOOKING_STATUS = 'REQUEST_BOOKING_STATUS';
export const RECEIVE_BOOKING_STATUS = 'RECEIVE_BOOKING_STATUS';
export const REQUEST_RETURN_BOOKING = 'REQUEST_RETURN_BOOKING';
export const RECEIVE_RETURN_BOOKING = 'RECEIVE_RETURN_BOOKING';
export const REQUEST_RESOLVE_BOOKING = 'REQUEST_RESOLVE_BOOKING';
export const RECEIVE_RESOLVE_BOOKING = 'RECEIVE_RESOLVE_BOOKING';
export const REQUEST_CANCEL_BOOKING = 'REQUEST_CANCEL_BOOKING';
export const RECEIVE_CANCEL_BOOKING = 'RECEIVE_CANCEL_BOOKING';
export const REQUEST_DRIVER_BOOKINGS = 'REQUEST_DRIVER_BOOKINGS';
export const RECEIVE_DRIVER_BOOKINGS = 'RECEIVE_DRIVER_BOOKINGS';
export const REQUEST_HIRE_AGREEMENT_EMAIL = 'REQUEST_HIRE_AGREEMENT_EMAIL';
export const RECEIVE_HIRE_AGREEMENT_EMAIL = 'RECEIVE_HIRE_AGREEMENT_EMAIL';
export const REQUEST_BOOKING_COUNT = 'REQUEST_BOOKING_COUNT';
export const RECEIVE_BOOKING_COUNT = 'RECEIVE_BOOKING_COUNT';
export const REQUEST_BANKING_EXPORT_TOTALS = 'REQUEST_BANKING_EXPORT_TOTALS';
export const RECEIVE_BANKING_EXPORT_TOTALS = 'RECEIVE_BANKING_EXPORT_TOTALS';
export const REQUEST_BOOKING_SET_PROVISIONAL_VEHICLE =
  'REQUEST_BOOKING_SET_PROVISIONAL_VEHICLE';
export const RECEIVE_BOOKING_SET_PROVISIONAL_VEHICLE =
  'RECEIVE_BOOKING_SET_PROVISIONAL_VEHICLE';
export const REQUEST_BOOKING_INVOICE = 'REQUEST_BOOKING_INVOICE';
export const RECEIVE_BOOKING_INVOICE = 'RECEIVE_BOOKING_INVOICE';

// Postcodes
export const REQUEST_POSTCODE = 'REQUEST_POSTCODE';
export const RECEIVE_POSTCODE = 'RECEIVE_POSTCODE';

export const REQUEST_BANKING_EXPORTS = 'REQUEST_BANKING_EXPORTS';
export const RECEIVE_BANKING_EXPORTS = 'REQUEST_BANKING_EXPORTS';
export const REQUEST_BANKING_EXPORT = 'RECEIVE_BANKING_EXPORT';
export const RECEIVE_BANKING_EXPORT = 'RECEIVE_BANKING_EXPORT';

// Settings
export const REQUEST_SETTINGS = 'REQUEST_SETTINGS';
export const RECEIVE_SETTINGS = 'RECEIVE_SETTINGS';
export const REQUEST_UPDATE_SETTINGS = 'REQUEST_UPDATE_SETTINGS';
export const RECEIVE_UPDATE_SETTINGS = 'RECEIVE_UPDATE_SETTINGS';

// Servicing
export const REQUEST_VEHICLES_TO_SERVICE = 'REQUEST_VEHICLES_TO_SERVICE';
export const RECEIVE_VEHICLES_TO_SERVICE = 'RECEIVE_VEHICLES_TO_SERVICE';
export const REQUEST_TO_SERVICE_VEHICLE = 'REQUEST_TO_SERVICE_VEHICLE';
export const RECEIVE_TO_SERVICE_VEHICLE = 'RECEIVE_TO_SERVICE_VEHICLE';
export const REQUEST_SERVICE_HISTORY = 'REQUEST_SERVICE_HISTORY';
export const RECEIVE_SERVICE_HISTORY = 'RECEIVE_SERVICE_HISTORY';
